import gql from 'graphql-tag';
import { addressFormats } from '../AutoComplete/AddressFormats';

// eslint-disable-next-line import/prefer-default-export
export const getFieldOrder = (countryCode) => {
    const formatForCountry = Object.keys(addressFormats)
        .filter(k => k !== 'default')
        .filter(k => !!addressFormats[k].countries.find(l => l === countryCode));
    const key = formatForCountry[0] ? formatForCountry[0] : 'default';
    const fieldOrder = addressFormats[key];
    return fieldOrder;
};

export const FETCH_ENTITY = gql`
    query ($entityType: String!, $entityId: String!, $locale: String!){
        entitiesFetch(entityType: $entityType, entityId: $entityId, locale: $locale){
            ancestorId,
            name,
            localization,
            id,
            abbrv
        }
    }
`;

export const FETCH_COUNTRY_DATA = gql`
query ($country: String!, $locale: String!){
    allEntitiesFetch(country: $country, locale: $locale){
        cities {
            ancestorId,
            name,
            localization,
            id,
            ancestorLocalization
        }
    }
}
`;
